import diaporamaElement from "./diaporama.js";
import dynamicImage from "./dynamic/image.js";
import dynamicKeyboard from "./dynamic/keyboard.js";
import dynamicProgressBar from "./dynamic/progress.js";
import dynamicTextInput from "./dynamic/textInput.js";
import dynamicTimeOut from "./dynamic/timeOut.js";
import elementBase from "./elementBase.js"
import imageElement from "./image.js";
import textElement from "./text.js";
import gridElement from "./grid.js";
import colorElement from "./color.js";
import videoElement from "./video.js";

const creator = function(itemType, data = {}) {
    switch (itemType) {
        case "DynamicImage":
            return dynamicImage.fromObject(data);
        case "ImageElement":
            return imageElement.fromObject(data);
        case "ColorElement":
            return colorElement.fromObject(data);
        case "TextElement":
            return textElement.fromObject(data);
        case "DiaporamaElement":
            return diaporamaElement.fromObject(data);
        case "GridElement":
            return gridElement.fromObject(data);
        case "DynamicKeyboard":
            return dynamicKeyboard.fromObject(data);
        case "DynamicProgress":
            return dynamicProgressBar.fromObject(data);
        case "DynamicTextInput":
            return dynamicTextInput.fromObject(data);
        case "DynamicTimeOut":
            return dynamicTimeOut.fromObject(data);
        case "VideoElement":
            return videoElement.fromObject(data);
        default:
            console.log(itemType, data);
            return elementBase.fromObject(data);
    }
}
export default creator